<template>
	<div>
		<div class="modal" v-bind:class="[modalClass]" ref="modal">
			<div class="modal-dialog" role="document">
				<form class="modal-content" @submit.prevent="apply" :disabled="disabled || applyDisabled">
					<div class="modal-header">
						<h4 class="modal-title" v-i18n="title"></h4>
						<button type="button" class="close" @click="hide"
						        :disabled="disabled">&times;</button>
					</div>
					<div class="modal-body">
						<slot></slot>
					</div>
					<div class="modal-footer">
						<slot name="modal-footer"></slot>
						<button type="button" class="btn btn-link" @click="hide"
						        :disabled="disabled">
							{{'cancel' | format-message}}
						</button>
						<button type="submit" class="btn btn-link"
						        :disabled="disabled || applyDisabled">
							{{'ok' | format-message}}
						</button>
					</div>
				</form><!-- /.modal-content -->
			</div><!-- /.modal-dialog -->
		</div><!-- /.modal -->
	</div>
</template>

<script>
		import Modal from 'bootstrap/js/src/modal';
	import PimplWrapper from 'utils/pimpl';

	class Pimpl {
		constructor(component) {
			this.component = component;
			this.modal = null;
			this.hidden = true;
		}

		show() {
			if (this.hidden) {
				if (!this.modal) {
					let modalElement = this.component.$refs.modal;
					this.modal = new Modal(modalElement);
					$(modalElement).on('shown.bs.modal', function () {
						$(this).find('select:first,input:first,textarea:first').first().focus().select();
					}).on('shown.bs.modal', () => {
						this.hidden = false;
					}).on('hidden.bs.modal', () => {
						this.hidden = true;
					});
				}
				$(this.modal._element).appendTo(document.body); // because edit-expense is in fixed container
				this.modal.show();
			}
		}

		hide() {
			if (!this.hidden) {
				this.modal.hide();
				$(this.modal._element).appendTo(this.component.$el);
			}
		}

		destroy() {
			if (this.modal) {
				this.hide();
				this.modal.dispose();
			}
		}
	}

	export default {
		props: {
			title: String,
			modalClass: String,
			disabled: {type: Boolean, default: false},
			applyDisabled: {type: Boolean, default: false}
		},

		data() {
			return {
				p: new PimplWrapper(new Pimpl(this))
			}
		},

		destroyed() {
			this.p.impl.destroy();
		},

		methods: {
			show() {
				this.p.impl.show();
			},
			hide() {
				this.p.impl.hide();
			},
			apply() {
				this.$emit('apply');
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/ui/widgets/modal.vue